export const SZ_CASH_URL = 'https://sz.kz/cash';

export const SZ_MAIN_URL = 'https://sz.kz/index';
